import Footer from "../components/Footer";
import Header from "../components/Header";

export default function Subscription() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow h-full justify-center items-center flex mb-40">
        <div className="flex flex-col sm:flex-row justify-center place-items-center ">
          <div className="w-2/2 px-5 sm:px-0 ">
            <div className=" text-xl font-semibold">Subscription Plan</div>
            <div className=" text-sm pb-3">Issue Price:Rs.200</div>
            <table
              style={{
                fontFamily: "arial, sans-serif",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-96 pl-2"
                  >
                    Annual (Institutional) Subscription :
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    Rs.400
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#dddddd" }}>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-96 pl-2"
                  >
                    Annual (Individual) Subscription :
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    Rs.200
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className=" ml-4 mt-10 mb-10 sm:mb-0 sm:mt-0">
            <img className="h-72 w-48" src="mea.webp" alt="Mizoram Economic Review Cover" />
            <div className="text-sm font-semibold pt-2 text-center">
              ISSN 2581-7523
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
